
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.667 2.667c0-.737.597-1.334 1.333-1.334h4c.736 0 1.334.597 1.334 1.334V4h1.326a.64.64 0 01.012 0H14a.667.667 0 010 1.333h-.712l-.579 8.095a1.333 1.333 0 01-1.33 1.239H4.621c-.7 0-1.28-.54-1.33-1.239l-.578-8.095H2A.667.667 0 112 4h1.328a.64.64 0 01.012 0h1.327V2.667zM6 4h4V2.667H6V4zM4.05 5.333l.57 8h6.76l.57-8h-7.9zm2.617 1.334c.368 0 .667.298.667.666v4a.667.667 0 01-1.334 0v-4c0-.368.299-.666.667-.666zm2.667 0c.368 0 .666.298.666.666v4a.667.667 0 01-1.333 0v-4c0-.368.298-.666.667-.666z","fill":"#A0AEC0"}})])
          )
        }
      }
    